function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { FloatingFocusManager } from '@floating-ui/react';
import React from 'react';
import { Fade } from '../../../../foundations/transitions';
import { forwardRef, mergeRefs } from '../../../../utils';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Box } from '../../Box';
import { Portal } from '../../Portal';
import { fadeStyle } from '../BasePopover.theme';
import { usePopoverContext } from '../basePopover.utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var BasePopoverContent = forwardRef((props, propRef) => {
  var {
    refs,
    getFloatingProps,
    x,
    y,
    strategy,
    descriptionId,
    isOpen,
    triggeredByClick,
    context
  } = usePopoverContext();
  var styles = useMultiStyleConfig('BasePopover', {
    position: strategy,
    top: y,
    left: x
  });
  var ref = mergeRefs([refs.setFloating, propRef]);
  return /*#__PURE__*/_jsx(Portal, {
    children: /*#__PURE__*/_jsx(Fade, {
      in: isOpen,
      unmountOnExit: true,
      style: fadeStyle,
      children: /*#__PURE__*/_jsx(FloatingFocusManager, {
        context: context,
        modal: false,
        returnFocus: triggeredByClick,
        children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
          __css: styles['content'],
          "data-component": props['data-component'],
          ref: ref,
          "aria-describedby": descriptionId
        }, getFloatingProps(props)), {}, {
          onClick: event => event.stopPropagation()
        }))
      })
    })
  });
});
BasePopoverContent.displayName = 'BasePopoverContent';
//# sourceMappingURL=BasePopoverContent.js.map